// via http://hackage.haskell.org/package/glider-nlp-0.1/docs/src/Glider-NLP-Language-Polish-StopWords.html
module.exports = {
    stopwords:[
        "a",
"aby",
"ach",
"acz",
"aczkolwiek",
"aj",
"albo",
"ale",
"alez",
"ależ",
"ani",
"az",
"aż",
"bardziej",
"bardzo",
"bo",
"bowiem",
"by",
"byli",
"bynajmniej",
"byc",
"być",
"byl",
"był",
"byla",
"bylo",
"byly",
"była",
"było",
"były",
"bedzie",
"będzie",
"beda",
"będą",
"cali",
"cala",
"cała",
"caly",
"cały",
"ci",
"cie",
"cię",
"ciebie",
"co",
"cokolwiek",
"cos",
"coś",
"czasami",
"czasem",
"czemu",
"czy",
"czyli",
"daleko",
"dla",
"dlaczego",
"dlatego",
"do",
"dobrze",
"dokad",
"dokąd",
"dosc",
"dość",
"duzo",
"dużo",
"dwa",
"dwaj",
"dwie",
"dwoje",
"dzis",
"dziś",
"dzisiaj",
"gdy",
"gdyby",
"gdyz",
"gdyż",
"gdzie",
"gdziekolwiek",
"gdzies",
"gdzieś",
"go",
"i",
"ich",
"ile",
"im",
"inna",
"inne",
"inny",
"innych",
"iz",
"iż",
"ja",
"ją",
"jak",
"jakas",
"jakaś",
"jakby",
"jaki",
"jakichs",
"jakichś",
"jakie",
"jakis",
"jakiś",
"jakiz",
"jakiż",
"jakkolwiek",
"jako",
"jakos",
"jakoś",
"je",
"jeden",
"jedna",
"jedno",
"jednak",
"jednakze",
"jednakże",
"jego",
"jej",
"jemu",
"jest",
"jestem",
"jeszcze",
"jesli",
"jeśli",
"jezeli",
"jeżeli",
"juz",
"już",
"kazdy",
"każdy",
"kiedy",
"kilka",
"kims",
"kimś",
"kto",
"ktokolwiek",
"ktos",
"ktoś",
"ktora",
"ktore",
"które",
"ktorego",
"ktorej",
"ktory",
"ktorych",
"ktorym",
"ktorzy",
"która",
"którego",
"której",
"który",
"których",
"którym",
"którzy",
"ku",
"lat",
"lecz",
"lub",
"ma",
"mają",
"mało",
"mam",
"mi",
"mimo",
"miedzy",
"między",
"mna",
"mną",
"mnie",
"moga",
"mogą",
"moi",
"moim",
"moja",
"moje",
"moze",
"może",
"mozliwe",
"mozna",
"możliwe",
"można",
"moj",
"mój",
"mu",
"musi",
"my",
"na",
"nad",
"nam",
"nami",
"nas",
"nasi",
"nasz",
"nasza",
"nasze",
"naszego",
"naszych",
"natomiast",
"natychmiast",
"nawet",
"nia",
"nią",
"nic",
"nich",
"nie",
"niech",
"niego",
"niej",
"niemu",
"nigdy",
"nim",
"nimi",
"niz",
"niż",
"no",
"o",
"obok",
"od",
"około",
"on",
"ona",
"one",
"oni",
"ono",
"oraz",
"oto",
"owszem",
"pan",
"pana",
"pani",
"po",
"pod",
"podczas",
"pomimo",
"ponad",
"poniewaz",
"ponieważ",
"powinien",
"powinna",
"powinni",
"powinno",
"poza",
"prawie",
"przeciez",
"przecież",
"przed",
"przede",
"przedtem",
"przez",
"przy",
"roku",
"rowniez",
"również",
"sam",
"sama",
"są",
"sie",
"się",
"skad",
"skąd",
"sobie",
"soba",
"sobą",
"sposob",
"sposób",
"swoje",
"ta",
"tak",
"taka",
"taki",
"takie",
"takze",
"także",
"tam",
"te",
"tego",
"tej",
"ten",
"teraz",
"też",
"to",
"toba",
"tobą",
"tobie",
"totez",
"toteż",
"trzeba",
"tu",
"tutaj",
"twoi",
"twoim",
"twoja",
"twoje",
"twym",
"twoj",
"twój",
"ty",
"tych",
"tylko",
"tym",
"u",
"w",
"wam",
"wami",
"was",
"wasz",
"wasza",
"wasze",
"we",
"według",
"wiele",
"wielu",
"więc",
"więcej",
"wszyscy",
"wszystkich",
"wszystkie",
"wszystkim",
"wszystko",
"wtedy",
"wy",
"wlasnie",
"właśnie",
"z",
"za",
"zapewne",
"zawsze",
"ze",
"znowu",
"znow",
"znów",
"zostal",
"został",
"zaden",
"zadna",
"zadne",
"zadnych",
"ze",
"zeby",
"żaden",
"żadna",
"żadne",
"żadnych",
"że",
"żeby"
    ]
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/keyword-extractor/lib/stopwords/pl.js
 ** module id = 2986
 ** module chunks = 0
 **/